import {useCallback} from 'react';
import {useNavigate} from 'react-router';

import {useDocumentRepository} from '@/components/document/repository';
import {useDocumentUtils} from '@/components/document/utils';
import {APP_PATH} from '@/constants/routes';
import {useConfig} from '@/contexts/config';
import {VisibilitySet} from '@/engine/types/document-model/document-model';
import {serializeDocument, serializeDocumentForSignature} from '@/utils/document/serializer';

type Props = {
  visibilitySet: VisibilitySet;
};

export const useResubmitForSignature = ({visibilitySet}: Props) => {
  const navigate = useNavigate();
  const {model} = useConfig();
  const {store, valueResolver} = useDocumentUtils();
  const {resubmitDocumentForSignature} = useDocumentRepository();

  return useCallback(async () => {
    const state = store.getState();

    const serializedDocument = serializeDocumentForSignature(
      {data: state.data, meta: state.meta},
      model,
      visibilitySet,
      valueResolver,
    );

    const updatedDocument = serializeDocument(
      {data: state.data, meta: state.meta},
      model,
      visibilitySet,
      valueResolver,
    );

    await resubmitDocumentForSignature(serializedDocument, updatedDocument);
    await navigate(APP_PATH, {state: {isSubmitForSignature: true}});
  }, [store, model, visibilitySet, valueResolver, resubmitDocumentForSignature, navigate]);
};
